export const TOAST_CONFIG = {
  enabled: false, // Set this to false to disable all toasts
}; 